import AuthenticationService from "@services/AuthenticationService";
import getRoutePath from "../../../routes/getRoutePath";
import { useHistory } from "react-router";

const Logout = () => {
  const history = useHistory();
  AuthenticationService.logout();

  history.push(getRoutePath("/login"));

  return null;
};

export default Logout;
